import { render, staticRenderFns } from "./StatsLift.vue?vue&type=template&id=236eae57"
import script from "./StatsLift.vue?vue&type=script&lang=js"
export * from "./StatsLift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports